export default {
  name: 'noLeadingNumber',
  validator(value, leadingNumber) {
    return Number(value.split('')[0]) !== leadingNumber[0]
  }
}
